/**
 * "Start from a template" (EMR-02): the common visits named in Admin v2, as
 * SOAP headings with the working diagnosis. The clinic supplies its own
 * template wording; the doctor edits each note for the patient.
 */
export const NOTE_TEMPLATES: { key: string; label: string; text: string }[] = [
  {
    key: 'urti',
    label: 'URTI',
    text: 'S: \nO: \nA: Upper respiratory tract infection\nP: ',
  },
  {
    key: 'gastro',
    label: 'Gastroenteritis',
    text: 'S: \nO: \nA: Gastroenteritis\nP: ',
  },
  {
    key: 'diabetes',
    label: 'Diabetes review',
    text: 'S: \nO: \nA: Diabetes review\nP: ',
  },
  {
    key: 'hypertension',
    label: 'Hypertension review',
    text: 'S: \nO: \nA: Hypertension review\nP: ',
  },
  { key: 'wound', label: 'Wound', text: 'S: \nO: \nA: Wound\nP: ' },
  {
    key: 'dengue',
    label: 'Suspected dengue',
    text: 'S: \nO: \nA: Suspected dengue\nP: ',
  },
];

/**
 * RL-2186: choosing a template replaces the notes when they are empty or still
 * an untouched template; anything the doctor typed is never overwritten
 * without a confirmation.
 */
export function templateNotesAction(
  notes: string,
  templateText: string,
): 'set' | 'confirm' {
  const current = notes.trim();
  if (!current) return 'set';
  if (current === templateText.trim()) return 'set';
  return NOTE_TEMPLATES.some((t) => t.text.trim() === current)
    ? 'set'
    : 'confirm';
}
